import { render, staticRenderFns } from "./ElementLottiePlayer.vue?vue&type=template&id=8c026bc0&"
import script from "./ElementLottiePlayer.vue?vue&type=script&lang=js&"
export * from "./ElementLottiePlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports